import { useState } from 'react';

import { SmallText } from 'inpock-ui-react';

import { Table } from '@/components';

import * as S from './styled';

interface FooterInfo {
  info: {
    [key: string]: string;
  };
}

export function MarketFooter({ info }: FooterInfo) {
  const [isInfoOpen, setIsInfoOpen] = useState<boolean>(false);

  return (
    <S.MarketFooter>
      <div className="creator-info" onClick={() => setIsInfoOpen(!isInfoOpen)}>
        <SmallText color="gray600">사업자 정보</SmallText>
        <div className={`arrow-icon ${isInfoOpen ? 'up' : 'down'}`} />
      </div>
      {isInfoOpen && (
        <div className="table-wrapper">
          <Table tbody={info} />
        </div>
      )}
      <div className="extra-info">
        <div className="service-provider">
          <SmallText className="text-bold text-gray-600">서비스 제공자</SmallText>
          <SmallText color="gray600">에이비제트(주)</SmallText>
        </div>
        <SmallText color="gray500">
          {info.company_name}은/는 통신판매의 당사자가 아닙니다. 상품, 상품정보, 거래에 관한 의무와
          책임은 판매자에게 있습니다.
        </SmallText>
      </div>
    </S.MarketFooter>
  );
}
